import {
  ADD_LABEL,
  CREATE_CONTACT,
  DELETE_CONTACT,
  DELETE_LABEL_ITEM,
  GET_CONTACT_COUNTS,
  GET_CONTACTS_LIST,
  GET_LABELS_LIST,
  SET_CURRENT_CONTACT,
  SET_FILTER_TYPE,
  TOGGLE_SIDEBAR_COLLAPSED,
  UPDATE_CONTACT,
  UPDATE_CONTACT_LABEL,
  UPDATE_LABEL_ITEM,
  UPDATE_STARRED_STATUS,
} from '../../@jumbo/constants/ActionTypes';
import {
  GENERIC_APP_ADD_LABEL,
  GENERIC_APP_GET_RECORDS_LIST_SUCCESS, GENERIC_APP_SET_CURRENT_PAGE_LIMIT,
  GENERIC_APP_SET_CURRENT_PAGE_NO,
  GENERIC_APP_SET_CURRENT_RECORD, GENERIC_APP_SET_DIALOG,
  GENERIC_APP_SET_FILTER_TYPE, GENERIC_APP_SET_FORM_CONTAINER_OPEN, GENERIC_APP_SHOW_DIALOG
} from "../action-types/GenericAppActionTypes";

const INIT_STATE = {
  isSideBarCollapsed: false,
  labelsList: [],
  filterType: {
    selectedFolder: 'contacts',
    selectedLabel: '',
    searchText: '',
  },
  recordList: [],
  currentRecord: null,
  totalRecords: null,
  counter: null,
  page: 0,
  pageLimit: 10,
  pageCount: 0,
  isFormContainerOpen: false,
  currentDialog : {
    title: '',
    position: 'center',
    icon: 'success',
    timer: 3000,
    show: false
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR_COLLAPSED: {
      return {
        ...state,
        isSideBarCollapsed: action.payload ? action.payload : !state.isSideBarCollapsed,
      };
    }

    case GENERIC_APP_SET_FILTER_TYPE: {
      return {
        ...state,
        filterType: action.payload,
      };
    }

    case GET_LABELS_LIST: {
      return { ...state, labelsList: action.payload };
    }

    case GENERIC_APP_ADD_LABEL: {
      return {
        ...state,
        labelsList: state.labelsList.concat(action.payload),
      };
    }

    case UPDATE_LABEL_ITEM: {
      return {
        ...state,
        labelsList: state.labelsList.map(item => (item.id === action.payload.id ? action.payload : item)),
      };
    }

    case DELETE_LABEL_ITEM: {
      return {
        ...state,
        labelsList: state.labelsList.filter(item => item.id !== action.payload),
      };
    }

    case GENERIC_APP_GET_RECORDS_LIST_SUCCESS: {
      return {
        ...state,
        recordList: action.payload.data,
        totalRecords: action.payload.count,
        pageLimit: action.payload.limit,
        pageCount: action.payload.pageCount,
        // page: action.payload.page,
      };
    }

    case GENERIC_APP_SET_CURRENT_RECORD: {
      return {
        ...state,
        currentRecord: action.payload,
      };
    }

    case CREATE_CONTACT: {
      let updatedList = state.contactsList;
      let updatedCount = state.totalContacts;
      if (state.filterType.selectedFolder === 'contacts') {
        updatedList = [action.payload, ...updatedList];
        updatedCount = updatedCount + 1;
      }
      return {
        ...state,
        recordList: updatedList,
        totalContacts: updatedCount,
      };
    }

    case UPDATE_CONTACT: {
      return {
        ...state,
        recordList: state.recordList.map(item => (item.id === action.payload.id ? action.payload : item)),
      };
    }

    case UPDATE_STARRED_STATUS: {
      const { contactIds, status } = action.payload;
      let updatedList = state.recordList.map(contact => {
        if (contactIds.includes(contact.id)) {
          contact.starred = status;
          return contact;
        }
        return contact;
      });
      if (!status && state.filterType.selectedFolder === 'starred') {
        updatedList = updatedList.filter(item => !contactIds.includes(item.id));
      }
      return {
        ...state,
        recordList: updatedList,
      };
    }

    case DELETE_CONTACT: {
      let updatedList = state.recordList;
      let updatedCount = state.totalContacts;
      if (state.filterType.selectedFolder !== 'trash') {
        updatedList = updatedList.filter(contact => !action.payload.includes(contact.id));
        updatedCount = updatedCount - action.payload.length;
      }
      return {
        ...state,
        recordList: updatedList,
        totalContacts: updatedCount,
      };
    }

    case UPDATE_CONTACT_LABEL: {
      let contactIds = action.payload.map(contact => contact.id);
      const updatedList = state.recordList.map(mail => {
        if (contactIds.includes(mail.id)) {
          return action.payload.find(selectedContact => selectedContact.id === mail.id);
        } else {
          return mail;
        }
      });
      return {
        ...state,
        recordList: updatedList,
      };
    }

    case GET_CONTACT_COUNTS: {
      return {
        ...state,
        counter: action.payload,
      };
    }

    case GENERIC_APP_SET_CURRENT_PAGE_NO: {
      return {
        ...state,
        page: action.payload,
      };
    }

    case GENERIC_APP_SET_CURRENT_PAGE_LIMIT: {
      return {
        ...state,
        pageLimit: action.payload,
        page: 0
      };
    }

    case GENERIC_APP_SET_DIALOG: {
      return {
        ...state,
        currentDialog: action.payload
      };
    }

    case GENERIC_APP_SET_FORM_CONTAINER_OPEN: {
      return {
        ...state,
        isFormContainerOpen: action.payload
      };
    }


    default:
      return state;
  }
};
